<template>
  <b-card style="border: 1px solid #0000001a">
    <b-col cols="12" class="d-flex justify-content-between align-items-center">
      <h5 class="font-weight-bolder">Notification Rules</h5>
      <b-button variant="primary" class="font-weight-bolder">
        <feather-icon icon="PlusIcon" />
        Create Rule</b-button
      >
    </b-col>

    <b-col cols="12" class="mt-1">
      <b-table
        :items="items"
        :fields="fields"
        responsive
        thead-class="text-nowrap"
      >
        <template #cell(channels)="{ item }">
          <div class="d-flex" style="gap: 6px; flex-wrap: wrap">
            <b-badge
              v-for="channel in item.channels"
              :key="channel"
              variant="primary"
              pill
            >
              {{ channel }}
            </b-badge>
          </div>
        </template>
        <template #cell(status)="{ item }">
          <b-badge :variant="getStatusVariant(item.status)" pill>
            {{ item.status }}
          </b-badge>
        </template>

        <!-- Actions column -->
        <template #cell(actions)>
          <div class="d-flex">
            <b-button size="sm" variant="link">
              <feather-icon icon="EditIcon" class="text-warning" />
            </b-button>
            <b-button size="sm" variant="link">
              <feather-icon icon="TrashIcon" class="text-danger" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-col>
  </b-card>
</template>

<script>
import { BCard, BButton, BTable, BBadge, BRow, BCol } from "bootstrap-vue";
export default {
  components: {
    BCard,
    BButton,
    BTable,
    BBadge,
    BRow,
    BCol,
  },
  data() {
    return {
      fields: [
        { key: "name", label: "RULE NAME" },
        { key: "trigger", label: "TRIGGER" },
        { key: "channels", label: "CHANNELS" },
        { key: "conditions", label: "CONDITIONS" },
        { key: "status", label: "STATUS" },
        { key: "actions", label: "ACTIONS" },
      ],
      items: [
        {
          name: "Large Deposit Alert",
          trigger: "Deposit > $1000",
          channels: ["email", "sms"],
          conditions: "Amount > 1000 AND First deposit = false",
          status: "Active",
        },
        {
          name: "Suspicious Activity",
          trigger: "Multiple failed logins",
          channels: ["email", "push"],
          conditions: "Failed attempts > 3 within 5 minutes",
          status: "Active",
        },
        {
          name: "Welcome Series",
          trigger: "New user registration",
          channels: ["email"],
          conditions: "Account created AND Email verified",
          status: "Active",
        },
        {
          name: "Promotion Reminder",
          trigger: "Promotion expires soon",
          channels: ["email", "push"],
          conditions:
            "Promotion expires in 24 hours AND User has eligible balance",
          status: "Active",
        },
        {
          name: "Withdrawal Review",
          trigger: "Withdrawal requires review",
          channels: ["email"],
          conditions: "Withdrawal amount > $5000 OR AML flags detected",
          status: "Inactive",
        },
        {
          name: "Test Rule 1",
          trigger: "Trigger example",
          channels: ["push"],
          conditions: "Condition example",
          status: "Active",
        },
        {
          name: "Test Rule 2",
          trigger: "Trigger example",
          channels: ["email"],
          conditions: "Condition example",
          status: "Inactive",
        },
      ],
    };
  },
  methods: {
    getStatusVariant(status) {
      switch (status) {
        case "Active":
          return "success";
        case "Pending":
          return "warning";
        case "Inactive":
          return "danger";
        default:
          return "secondary";
      }
    },
  },
};
</script>
